import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<mask id=\"mask0_pt\" style=\"mask-type:alpha;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"20\" height=\"20\"><circle cx=\"10\" cy=\"10\" r=\"10\" fill=\"#D9D9D9\"></circle></mask><g mask=\"url(#mask0_pt)\"><rect width=\"8\" height=\"20\" fill=\"#006600\"></rect><rect x=\"8\" width=\"12\" height=\"20\" fill=\"#FF0000\"></rect><circle cx=\"8\" cy=\"10\" r=\"3.5\" fill=\"#FFCC29\"></circle><circle cx=\"8\" cy=\"10\" r=\"2.5\" fill=\"#FF0000\"></circle><circle cx=\"8\" cy=\"10\" r=\"1.5\" fill=\"#ffffff\"></circle></g>", 2)
  ])))
}
export default { render: render }